import Link from "../components/Link";
import PageHero from "../components/PageHero";
import Reveal from "../components/Reveal";

export default function About() {
  const steps = [
    ["Arrive", "A private ladies-only space where the appointment begins with attention, comfort, and calm."],
    ["Design", "Artists shape the look or treatment around your event, skin, hair, mood, and timeline."],
    ["Transform", "Every detail is refined so the final result feels polished, personal, and celebratory."],
  ];

  return (
    <>
      <PageHero
        eyebrow="About Orchid"
        title="A sanctuary crafted exclusively for women."
        desc="Luxury services, thoughtful care, and academy-level craft in Bengaluru."
        image="https://images.unsplash.com/photo-1512290923902-8a9f81dc236c?w=1700&auto=format&fit=crop&q=76"
      />

      <section className="section-pad">
        <div className="container split-grid">
          <Reveal className="stack-content">
            <p className="section-eyebrow">About Us</p>
            <h2 className="section-title">Every visit is treated like a celebration.</h2>
            <p className="lead">
              A premium beauty sanctuary in Bengaluru offering world-class services exclusively for women -
              where every visit is a celebration.
            </p>
            <p>
              Orchid Salon & Academy brings together bridal makeup, hair styling, skin treatment, spa rituals,
              nail services, and professional training in one refined studio experience.
            </p>
            <ul className="check-grid">
              <li>Certified Artists</li>
              <li>Private Appointments</li>
              <li>Luxury Finish</li>
              <li>Academy Expertise</li>
            </ul>
          </Reveal>

          <Reveal delay={120} className="tilt-visual bits-tilt">
            <img
              src="https://images.unsplash.com/photo-1560869713-7d0a29430803?w=1000&auto=format&fit=crop&q=74"
              alt="Salon consultation"
            />
            <div className="floating-note bits-spotlight">
              <strong>500+ happy clients</strong>
              <span>Beauty that feels personal, polished, and calm.</span>
            </div>
          </Reveal>
        </div>
      </section>

      <section className="section-pad warm-section">
        <div className="container method-grid">
          <Reveal>
            <p className="section-eyebrow">The Method</p>
            <h2 className="section-title">A beauty experience that feels personal from minute one.</h2>
            <p className="section-desc">
              Instead of treating every client the same, Orchid maps services around occasion, comfort,
              craft, and care. The result is a calmer, more confident transformation.
            </p>
            <Link to="/contact" className="btn-outline"><span>Book Your Session</span></Link>
          </Reveal>

          <div className="method-steps">
            {steps.map(([title, desc], index) => (
              <Reveal delay={index * 80} key={title}>
                <article className="method-card bits-spotlight">
                  <span>{String(index + 1).padStart(2, "0")}</span>
                  <h3>{title}</h3>
                  <p>{desc}</p>
                </article>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
